/**
 * Иконки новой темы меню. Перенесены как есть из прототипа редизайна
 * (Phosphor-набор, viewBox 256, fill=currentColor) — размеры задаёт CSS.
 */
import React from 'react'

type IconProps = { className?: string }

function SvgLine(props: { children: React.ReactNode; className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={props.className}
    >
      {props.children}
    </svg>
  )
}

function Svg(props: { children: React.ReactNode; className?: string }) {
  return (
    <svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" className={props.className}>
      {props.children}
    </svg>
  )
}

export function PlusIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M228,128a12,12,0,0,1-12,12H140v76a12,12,0,0,1-24,0V140H40a12,12,0,0,1,0-24h76V40a12,12,0,0,1,24,0v76h76A12,12,0,0,1,228,128Z" />
    </Svg>
  )
}

export function MinusIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128Z" />
    </Svg>
  )
}

export function TrashIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M216,48H180V36A28,28,0,0,0,152,8H104A28,28,0,0,0,76,36V48H40a12,12,0,0,0,0,24h4V208a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V72h4a12,12,0,0,0,0-24ZM100,36a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4V48H100Zm88,168H68V72H188ZM116,104v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Zm48,0v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Z" />
    </Svg>
  )
}

export function SlidersIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M40,88H73a32,32,0,0,0,62,0h81a8,8,0,0,0,0-16H135a32,32,0,0,0-62,0H40a8,8,0,0,0,0,16Zm64-24A16,16,0,1,1,88,80,16,16,0,0,1,104,64ZM216,168H199a32,32,0,0,0-62,0H40a8,8,0,0,0,0,16h97a32,32,0,0,0,62,0h17a8,8,0,0,0,0-16Zm-48,24a16,16,0,1,1,16-16A16,16,0,0,1,168,192Z" />
    </Svg>
  )
}

export function BowlIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M72,88V40a8,8,0,0,1,16,0V88a8,8,0,0,1-16,0ZM216,40V224a8,8,0,0,1-16,0V176H152a8,8,0,0,1-8-8,268.75,268.75,0,0,1,7.22-56.88c9.78-40.49,28.32-67.63,53.63-78.47A8,8,0,0,1,216,40ZM200,53.9c-32.17,24.57-38.47,84.42-39.7,106.1H200ZM119.89,38.69a8,8,0,1,0-15.78,2.63L112,88.63a32,32,0,0,1-64,0l7.88-47.31a8,8,0,1,0-15.78-2.63l-8,48A8.17,8.17,0,0,0,32,88a48.07,48.07,0,0,0,40,47.32V224a8,8,0,0,0,16,0V135.32A48.07,48.07,0,0,0,128,88a8.17,8.17,0,0,0-.11-1.31Z" />
    </Svg>
  )
}

export function ViewCardsIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16v56H40V56Zm0,144H40V128H216v72Z" />
    </Svg>
  )
}

export function ViewListIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" />
    </Svg>
  )
}

/** Постер: кадр с полосой текста по низу. */
export function ViewPosterIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm0,16V152H56V40ZM56,216V168H200v48Z" />
    </Svg>
  )
}

export function ListIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm120,112H40a8,8,0,0,0,0,16H160a8,8,0,0,0,0-16Z" />
    </Svg>
  )
}

export function ClockIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.5V12l3 2" />
    </SvgLine>
  )
}

export function LeafIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M223.45,40.07a8,8,0,0,0-7.52-7.52C139.8,28.08,78.82,51,52.82,94a87.09,87.09,0,0,0-12.76,49c.57,15.92,5.21,32,13.79,47.85l-19.51,19.5a8,8,0,0,0,11.32,11.32l19.5-19.51C81,210.73,97.09,215.37,113,215.94q1.67.06,3.33.06A86.93,86.93,0,0,0,162,203.18C205,177.18,227.93,116.21,223.45,40.07ZM153.75,189.5c-22.75,13.78-49.68,14-76.71.77l88.63-88.62a8,8,0,0,0-11.32-11.32L65.73,179c-13.19-27-13-54,.77-76.71,22.09-36.47,74.6-56.44,141.31-54.06C210.2,114.89,190.22,167.41,153.75,189.5Z" />
    </Svg>
  )
}

export function PepperIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M167.27,40.42A40.06,40.06,0,0,0,128,8a8,8,0,0,0,0,16,24,24,0,0,1,22.85,16.66A64.08,64.08,0,0,0,96,104c0,46.75-25.75,78-76.53,93a16,16,0,0,0,1.77,31.13A264.8,264.8,0,0,0,66.75,232c40.78,0,86.16-9.15,117.53-35.46C210.64,174.44,224,143.3,224,104h0A64.07,64.07,0,0,0,167.27,40.42ZM160,56a48.07,48.07,0,0,1,45.37,32.37L192,95,163.58,80.83a8,8,0,0,0-7.16,0L128,95l-13.37-6.68A48.08,48.08,0,0,1,160,56Zm14,128.3c-18,15.07-43.6,25.26-74.12,29.47A254.08,254.08,0,0,1,24,212.37h0v0c57.23-16.87,87.63-54,88-107.42l12.44,6.22a8,8,0,0,0,7.16,0L160,96.93l28.42,14.21a8,8,0,0,0,7.16,0l12.41-6.2C207.78,138.84,196.35,165.54,174,184.29Z" />
    </Svg>
  )
}

/**
 * «Очень острое» — по референсу заведения: перчик на фоне языков пламени.
 * Для «острого» используется обычный перчик без огня.
 */
export function PepperFireIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={props.className}
    >
      {/* язык пламени за перчиком — целиком внутри поля значка */}
      <path d="M17 8.5c-3.4 3-4.6 6.6-2.9 9.7 1 1.9-.1 3.9-2 4.2-1.6.3-2.9-.9-2.9-2.6-2 4-1.2 8.8 2.1 12" />
      <path d="M23 12c-1.9 2.6-2.1 5-1 7.1 1.2 2.2.9 4.5-.9 6 3.4-.3 5.6-3.1 5.2-6.6-.2-1.8-1.4-3.4-3.3-6.5Z" />
      {/* перчик с хвостиком */}
      <path d="M36.5 18.5c1.9 1.8 2.8 4.5 2.3 7.7C37.6 34.8 29.3 41 21 41c-4.5 0-8.4-1.6-10.8-4.3-.8-.9 0-2.2 1.1-1.9 7 2.2 12-.3 15.7-6.9l3.1-5.6c1.3-2.3 3.2-3.8 5.8-4.3" />
      <path d="M35.6 18.9c1.4-2.7 2.9-5.1 4.5-7.2-.8-1.1-1.9-1.4-3-.6-1.8 2.1-3.4 4.4-4.6 6.9" />
    </svg>
  )
}

export function SparkleIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z" />
    </Svg>
  )
}

export function CheckIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z" />
    </Svg>
  )
}

export function InfoIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z" />
    </Svg>
  )
}

/** «Новинка» — звезда: понятнее, чем искры */
export function StarIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M239.2,97.29a16,16,0,0,0-13.81-11L166,81.17,142.72,25.81h0a15.95,15.95,0,0,0-29.44,0L90.07,81.17,30.61,86.32a16,16,0,0,0-9.11,28.06L66.61,153.8,53.09,212.34a16,16,0,0,0,23.84,17.34l51-31,51.11,31a16,16,0,0,0,23.84-17.34l-13.51-58.54,45.1-39.42A16,16,0,0,0,239.2,97.29Z" />
    </Svg>
  )
}

/** морковь — вегетарианское */
export function CarrotIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M128,88a8,8,0,0,1,5.66,2.34l72,72a8,8,0,0,1-2.83,13.16l-120,44A8,8,0,0,1,72.5,208.9l-44-120a8,8,0,0,1,10.34-10.16l44,16A8,8,0,0,1,128,88Zm-45.34,26L54.1,103.62l33.5,91.42,91.42-33.5Z" />
      <path d="M160,72a24,24,0,0,1,24-24,8,8,0,0,0,0-16,40,40,0,0,0-40,40,8,8,0,0,0,16,0Z" />
    </Svg>
  )
}

/** рыба — пескетарианское */
export function FishIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M232,120c-12-20-40-56-96-56S52,100,40,120a16,16,0,0,0,0,16c12,20,40,56,96,56s84-36,96-56A16,16,0,0,0,232,120Zm-96,56c-44,0-68-28-80-48,12-20,36-48,80-48s68,28,80,48C204,148,180,176,136,176Zm-16-56a12,12,0,1,1,12,12A12,12,0,0,1,120,120Z" />
      <path d="M40,72,16,56V200l24-16Z" />
    </Svg>
  )
}

/** колос — без глютена */
export function GrainIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <path d="M12 21V9" />
      <path d="M12 9c0-2.2 1.3-4 3-4 0 2.2-1.3 4-3 4Zm0 0c0-2.2-1.3-4-3-4 0 2.2 1.3 4 3 4Z" />
      <path d="M12 14c0-2.2 1.3-4 3-4 0 2.2-1.3 4-3 4Zm0 0c0-2.2-1.3-4-3-4 0 2.2 1.3 4 3 4Z" />
      <path d="M12 19c0-2.2 1.3-4 3-4 0 2.2-1.3 4-3 4Zm0 0c0-2.2-1.3-4-3-4 0 2.2 1.3 4 3 4Z" />
    </SvgLine>
  )
}

/**
 * «Без глютена» — по референсу заведения: колос в перечёркнутом круге.
 */
export function GlutenFreeIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={props.className}
    >
      <circle cx="24" cy="24" r="20" />
      <path d="M9.8 38.2 38.2 9.8" />
      <path d="M24 37v-6" />
      <path d="M24 24.5c-2.6-2.6-2.6-6.9 0-9.5 2.6 2.6 2.6 6.9 0 9.5Z" />
      <path d="M23.4 25.6c-3.7 0-6.7-3-6.7-6.7 3.7 0 6.7 3 6.7 6.7Z" />
      <path d="M24.6 25.6c3.7 0 6.7-3 6.7-6.7-3.7 0-6.7 3-6.7 6.7Z" />
      <path d="M23.4 32c-3.7 0-6.7-3-6.7-6.7 3.7 0 6.7 3 6.7 6.7Z" />
      <path d="M24.6 32c3.7 0 6.7-3 6.7-6.7-3.7 0-6.7 3-6.7 6.7Z" />
    </svg>
  )
}

/**
 * «Новинка» — по референсу заведения: печать-розетка с надписью NEW.
 */
export function NewIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={props.className}
    >
      <path
        className="rosette-fill"
        stroke="none"
        d="M44.5 24.0Q44.5 24.0 44.3 24.7Q44.0 25.3 43.4 25.9Q42.8 26.5 42.2 27.0Q41.6 27.5 41.2 28.0Q40.9 28.5 40.9 29.1Q41.0 29.8 41.3 30.5Q41.6 31.3 41.8 32.1Q42.0 32.9 41.9 33.6Q41.8 34.2 41.2 34.7Q40.7 35.1 39.9 35.4Q39.1 35.6 38.3 35.7Q37.5 35.8 36.9 36.1Q36.4 36.4 36.1 36.9Q35.8 37.5 35.7 38.3Q35.6 39.1 35.4 39.9Q35.1 40.7 34.7 41.2Q34.2 41.8 33.6 41.9Q32.9 42.0 32.1 41.8Q31.3 41.6 30.5 41.3Q29.8 41.0 29.1 40.9Q28.5 40.9 28.0 41.2Q27.5 41.6 27.0 42.2Q26.5 42.8 25.9 43.4Q25.3 44.0 24.7 44.3Q24.0 44.5 23.3 44.3Q22.7 44.0 22.1 43.4Q21.5 42.8 21.0 42.2Q20.5 41.6 20.0 41.2Q19.5 40.9 18.9 40.9Q18.2 41.0 17.5 41.3Q16.7 41.6 15.9 41.8Q15.1 42.0 14.4 41.9Q13.8 41.8 13.3 41.2Q12.9 40.7 12.6 39.9Q12.4 39.1 12.3 38.3Q12.2 37.5 11.9 36.9Q11.6 36.4 11.1 36.1Q10.5 35.8 9.7 35.7Q8.9 35.6 8.1 35.4Q7.3 35.1 6.8 34.7Q6.2 34.2 6.1 33.6Q6.0 32.9 6.2 32.1Q6.4 31.3 6.7 30.5Q7.0 29.8 7.1 29.1Q7.1 28.5 6.8 28.0Q6.4 27.5 5.8 27.0Q5.2 26.5 4.6 25.9Q4.0 25.3 3.7 24.7Q3.5 24.0 3.7 23.3Q4.0 22.7 4.6 22.1Q5.2 21.5 5.8 21.0Q6.4 20.5 6.8 20.0Q7.1 19.5 7.1 18.9Q7.0 18.2 6.7 17.5Q6.4 16.7 6.2 15.9Q6.0 15.1 6.1 14.4Q6.2 13.8 6.8 13.3Q7.3 12.9 8.1 12.6Q8.9 12.4 9.7 12.3Q10.5 12.2 11.1 11.9Q11.6 11.6 11.9 11.1Q12.2 10.5 12.3 9.7Q12.4 8.9 12.6 8.1Q12.9 7.3 13.3 6.8Q13.7 6.2 14.4 6.1Q15.1 6.0 15.9 6.2Q16.7 6.4 17.5 6.7Q18.2 7.0 18.9 7.1Q19.5 7.1 20.0 6.8Q20.5 6.4 21.0 5.8Q21.5 5.2 22.1 4.6Q22.7 4.0 23.3 3.7Q24.0 3.5 24.7 3.7Q25.3 4.0 25.9 4.6Q26.5 5.2 27.0 5.8Q27.5 6.4 28.0 6.8Q28.5 7.1 29.1 7.1Q29.8 7.0 30.5 6.7Q31.3 6.4 32.1 6.2Q32.9 6.0 33.6 6.1Q34.2 6.2 34.7 6.8Q35.1 7.3 35.4 8.1Q35.6 8.9 35.7 9.7Q35.8 10.5 36.1 11.1Q36.4 11.6 36.9 11.9Q37.5 12.2 38.3 12.3Q39.1 12.4 39.9 12.6Q40.7 12.9 41.2 13.3Q41.8 13.7 41.9 14.4Q42.0 15.1 41.8 15.9Q41.6 16.7 41.3 17.5Q41.0 18.2 40.9 18.9Q40.9 19.5 41.2 20.0Q41.6 20.5 42.2 21.0Q42.8 21.5 43.4 22.1Q44.0 22.7 44.3 23.3Z"
      />
      <path d="M44.5 24.0Q44.5 24.0 44.3 24.7Q44.0 25.3 43.4 25.9Q42.8 26.5 42.2 27.0Q41.6 27.5 41.2 28.0Q40.9 28.5 40.9 29.1Q41.0 29.8 41.3 30.5Q41.6 31.3 41.8 32.1Q42.0 32.9 41.9 33.6Q41.8 34.2 41.2 34.7Q40.7 35.1 39.9 35.4Q39.1 35.6 38.3 35.7Q37.5 35.8 36.9 36.1Q36.4 36.4 36.1 36.9Q35.8 37.5 35.7 38.3Q35.6 39.1 35.4 39.9Q35.1 40.7 34.7 41.2Q34.2 41.8 33.6 41.9Q32.9 42.0 32.1 41.8Q31.3 41.6 30.5 41.3Q29.8 41.0 29.1 40.9Q28.5 40.9 28.0 41.2Q27.5 41.6 27.0 42.2Q26.5 42.8 25.9 43.4Q25.3 44.0 24.7 44.3Q24.0 44.5 23.3 44.3Q22.7 44.0 22.1 43.4Q21.5 42.8 21.0 42.2Q20.5 41.6 20.0 41.2Q19.5 40.9 18.9 40.9Q18.2 41.0 17.5 41.3Q16.7 41.6 15.9 41.8Q15.1 42.0 14.4 41.9Q13.8 41.8 13.3 41.2Q12.9 40.7 12.6 39.9Q12.4 39.1 12.3 38.3Q12.2 37.5 11.9 36.9Q11.6 36.4 11.1 36.1Q10.5 35.8 9.7 35.7Q8.9 35.6 8.1 35.4Q7.3 35.1 6.8 34.7Q6.2 34.2 6.1 33.6Q6.0 32.9 6.2 32.1Q6.4 31.3 6.7 30.5Q7.0 29.8 7.1 29.1Q7.1 28.5 6.8 28.0Q6.4 27.5 5.8 27.0Q5.2 26.5 4.6 25.9Q4.0 25.3 3.7 24.7Q3.5 24.0 3.7 23.3Q4.0 22.7 4.6 22.1Q5.2 21.5 5.8 21.0Q6.4 20.5 6.8 20.0Q7.1 19.5 7.1 18.9Q7.0 18.2 6.7 17.5Q6.4 16.7 6.2 15.9Q6.0 15.1 6.1 14.4Q6.2 13.8 6.8 13.3Q7.3 12.9 8.1 12.6Q8.9 12.4 9.7 12.3Q10.5 12.2 11.1 11.9Q11.6 11.6 11.9 11.1Q12.2 10.5 12.3 9.7Q12.4 8.9 12.6 8.1Q12.9 7.3 13.3 6.8Q13.7 6.2 14.4 6.1Q15.1 6.0 15.9 6.2Q16.7 6.4 17.5 6.7Q18.2 7.0 18.9 7.1Q19.5 7.1 20.0 6.8Q20.5 6.4 21.0 5.8Q21.5 5.2 22.1 4.6Q22.7 4.0 23.3 3.7Q24.0 3.5 24.7 3.7Q25.3 4.0 25.9 4.6Q26.5 5.2 27.0 5.8Q27.5 6.4 28.0 6.8Q28.5 7.1 29.1 7.1Q29.8 7.0 30.5 6.7Q31.3 6.4 32.1 6.2Q32.9 6.0 33.6 6.1Q34.2 6.2 34.7 6.8Q35.1 7.3 35.4 8.1Q35.6 8.9 35.7 9.7Q35.8 10.5 36.1 11.1Q36.4 11.6 36.9 11.9Q37.5 12.2 38.3 12.3Q39.1 12.4 39.9 12.6Q40.7 12.9 41.2 13.3Q41.8 13.7 41.9 14.4Q42.0 15.1 41.8 15.9Q41.6 16.7 41.3 17.5Q41.0 18.2 40.9 18.9Q40.9 19.5 41.2 20.0Q41.6 20.5 42.2 21.0Q42.8 21.5 43.4 22.1Q44.0 22.7 44.3 23.3Z" />
      <text
        x="24"
        y="28.5"
        fontSize="15"
        fontWeight="800"
        textAnchor="middle"
        transform="rotate(-20 24 24)"
        fill="currentColor"
        stroke="none"
      >
        NEW
      </text>
    </svg>
  )
}

/** капля — меньше сахара */
export function DropIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M128,24S56,96,56,152a72,72,0,0,0,144,0C200,96,128,24,128,24Zm0,184a56,56,0,0,1-56-56c0-38,42-84,56-98,14,14,56,60,56,98A56,56,0,0,1,128,208Z" />
    </Svg>
  )
}

/** улыбка — подходит детям */
export function SmileIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <circle cx="12" cy="13" r="7.5" />
      <path d="M4.2 10.4a2.6 2.6 0 0 0 0 5.2m15.6-5.2a2.6 2.6 0 0 1 0 5.2" />
      <path d="M9 6.2a2.6 2.6 0 1 0 2.6-2.6H10" />
      <path d="M9.4 12.4h.01M14.6 12.4h.01" />
      <path d="M9.6 16.2a3 3 0 0 0 4.8 0" />
    </SvgLine>
  )
}

/** перечёркнутый круг — без острого / без алкоголя */
export function ProhibitIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm88,104a87.57,87.57,0,0,1-20.41,56.28L71.72,60.41A88,88,0,0,1,216,128ZM40,128A87.57,87.57,0,0,1,60.41,71.72L184.28,195.59A88,88,0,0,1,40,128Z" />
    </Svg>
  )
}

/** росток — постное меню */
export function SproutIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M128,120a8,8,0,0,1,8,8V224a8,8,0,0,1-16,0V128A8,8,0,0,1,128,120Z" />
      <path d="M120,128A72,72,0,0,1,48,56a8,8,0,0,1,8-8,72,72,0,0,1,72,72,8,8,0,0,1-8,8Zm16-24a72,72,0,0,1,72-72,8,8,0,0,1,8,8,72,72,0,0,1-72,72,8,8,0,0,1-8-8Z" />
    </Svg>
  )
}

/** Метка адреса для строки доставки .co-addr. */
export function PinIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <path d="M12 21s7-5.2 7-11a7 7 0 1 0-14 0c0 5.8 7 11 7 11Z" />
      <circle cx="12" cy="10" r="2.6" />
    </SvgLine>
  )
}

/** Шеврон вправо — раскрытие строки адреса. */
export function ChevronRightIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <path d="m9 5 7 7-7 7" />
    </SvgLine>
  )
}

/** Контакты гостя — строка данных в оформлении. */
export function UserIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <circle cx="12" cy="8" r="3.6" />
      <path d="M4.8 20a7.2 7.2 0 0 1 14.4 0" />
    </SvgLine>
  )
}

/** Правка блюда — инструмент админского вида. */
export function PencilIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z" />
    </Svg>
  )
}

/** Снимок блюда — инструмент админского вида. */
export function PictureIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V158.75l-26.07-26.06a16,16,0,0,0-22.63,0l-20,20-44-44a16,16,0,0,0-22.62,0L40,149.37V56ZM40,172l52-52,80,80H40Zm176,28H194.63l-36-36,20-20L216,181.38V200ZM144,100a12,12,0,1,1,12,12A12,12,0,0,1,144,100Z" />
    </Svg>
  )
}

/** Перенос выше — плотная стрелка набора, как остальные инструменты. */
export function ArrowUpIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M208.49,120.49a12,12,0,0,1-17,0L140,69V216a12,12,0,0,1-24,0V69L64.49,120.49a12,12,0,0,1-17-17l72-72a12,12,0,0,1,17,0l72,72A12,12,0,0,1,208.49,120.49Z" />
    </Svg>
  )
}

/** Перенос ниже. */
export function ArrowDownIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M208.49,152.49l-72,72a12,12,0,0,1-17,0l-72-72a12,12,0,0,1,17-17L116,187V40a12,12,0,0,1,24,0V187l51.51-51.52a12,12,0,0,1,17,17Z" />
    </Svg>
  )
}

/** Пауза — «в стоп-листе»: блюдо временно снято с продажи. */
export function PauseIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <path d="M9 5v14M15 5v14" />
    </SvgLine>
  )
}

/** Глаз — «предпросмотр»: меню глазами гостя. */
export function EyeIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z" />
      <circle cx="12" cy="12" r="3" />
    </SvgLine>
  )
}

/** Шестерёнка — «панель управления». */
export function GearIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2Z" />
      <circle cx="12" cy="12" r="3" />
    </SvgLine>
  )
}

/** Троеточие — «ещё действия» на карточке блюда. */
export function DotsIcon(props: IconProps) {
  return (
    <Svg className={props.className}>
      <path d="M156,128a28,28,0,1,1-28-28A28,28,0,0,1,156,128ZM48,100a28,28,0,1,0,28,28A28,28,0,0,0,48,100Zm160,0a28,28,0,1,0,28,28A28,28,0,0,0,208,100Z" />
    </Svg>
  )
}

/** Назад — штрихом, в один вес с остальными иконками темы. */
export function BackIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <path d="M15 5l-7 7 7 7" />
    </SvgLine>
  )
}

/** Плюс контуром — для кнопок .pill-btn, где иконки рисуются штрихом. */
export function PlusLineIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <path d="M12 5v14M5 12h14" />
    </SvgLine>
  )
}

/* ── знаки соцсетей ────────────────────────────────────────────────
   Начерчены той же линией 1.8, что и остальные штриховые значки темы:
   готового набора брендовых иконок в проекте нет. */
export function InstagramIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <rect x="3.4" y="3.4" width="17.2" height="17.2" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.1" cy="6.9" r="0.9" fill="currentColor" stroke="none" />
    </SvgLine>
  )
}

export function FacebookIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <path d="M14.8 7.6h1.7M14.8 7.6c-1.3 0-2.1.8-2.1 2.1V21M10 12.9h5.4" />
      <path d="M12.7 21V9.7c0-1.3.8-2.1 2.1-2.1h1.7" />
      <rect x="3.4" y="3.4" width="17.2" height="17.2" rx="5" />
    </SvgLine>
  )
}

export function VkIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <rect x="3.4" y="3.4" width="17.2" height="17.2" rx="5" />
      <path d="M6.9 9.2c.4 2.6 1.9 5.6 4.6 5.6h.6V9.2" />
      <path d="M17.3 9.2c-.6 1.7-1.7 3.1-3.1 4 1.4.6 2.5 1.7 3.1 3" />
    </SvgLine>
  )
}

export function TelegramIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <path d="M20.6 4.6 3.9 11.1c-.6.2-.6 1 0 1.2l4.2 1.4 1.6 4.6c.2.6.9.7 1.3.3l2.2-2.1 3.8 2.8c.5.3 1.1 0 1.2-.5l2.8-13c.1-.6-.5-1-1-.8z" />
      <path d="M8.1 13.7 18.6 6.4l-7.3 8.3-.1 3.4" />
    </SvgLine>
  )
}

export function TiktokIcon(props: IconProps) {
  return (
    <SvgLine className={props.className}>
      <path d="M14.4 3.6v10.7a3.8 3.8 0 1 1-3.1-3.7" />
      <path d="M14.4 3.6c.3 2.2 1.9 3.8 4.1 4" />
    </SvgLine>
  )
}
